import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useSocialText } from '@/social/use-social-text'
import { AtSign } from 'lucide-react'

export function UsernameRequiredPrompt({
  compact = false,
  onOpenProfile,
}: {
  compact?: boolean
  onOpenProfile: () => void
}) {
  const text = useSocialText()

  return (
    <Card
      className={compact ? 'm-3 gap-4 py-5 shadow-none' : 'mx-auto max-w-lg'}
    >
      <CardHeader className={compact ? 'px-4' : undefined}>
        <div className="mb-2 flex size-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <AtSign className="size-5" />
        </div>
        <CardTitle>
          {text('social.username.title', 'Choose your username')}
        </CardTitle>
        <CardDescription>
          {text(
            'social.username.requiredDescription',
            'Create your username in Profile before using friends and messages.',
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className={compact ? 'px-4' : undefined}>
        <Button type="button" className="w-full" onClick={onOpenProfile}>
          {text('social.username.openProfile', 'Go to Profile')}
        </Button>
      </CardContent>
    </Card>
  )
}
